import React, { Component } from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';

import Dashboard, { SPACE_ID as DASHBOARD_SPACE_ID } from './dashboard';
import StandaloneSpace, { SPACE_ID as STANDALONE_SPACE_ID } from './standalone';

// eslint-disable-next-line react/prefer-stateless-function
class SpacesContainer extends Component {
    render() {
        return (
            <Switch>
                <Route path={`/${DASHBOARD_SPACE_ID}`} component={Dashboard} />
                <Route path={`/${STANDALONE_SPACE_ID}`} component={StandaloneSpace} />
                <Route render={() => <Redirect to="/dashboard" />} />
            </Switch>
        );
    }
}

SpacesContainer.propTypes = {};

export default withRouter(SpacesContainer);
